<template>
    <section class="mt-16">
      <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-calendar-account</v-icon> <span>{{$t('holidays.crumb_add')}}</span>
        </h1>
  
        <div class="mt-16">
          <Holiday method="create"></Holiday>
        </div>
    </section>
  </template>
  <script>
  import Holiday from '@/components/holidays/Holiday'
  
  export default {
    components: {
        Holiday
    },
    beforeCreate(){
      document.title = "Report Lake - " + this.$t('holidays.crumb_add');
    },
    data: () => ({
      
    }),
    mounted(){
  
      if(!this.$root.session.hasPermission(["super", "holidays.create"])) {
        this.$router.push('/admin');
      }
  
    },
    methods:{
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin',
            exact: true,
          },
          {
            text: this.$t('menu.holidays_management'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin/workers-settings/holidays',
            exact: true,
          },
          {
            text: this.$t('holidays.crumb_add'),
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  